import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {EddlFormViewEvent} from '@app/services/analytics/EDDL/events/eddl-form-view-event';
import {SUPPORT_FORM_NAME} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';
import {ConfigService, SupportFormService} from '@dcp/configurator';
import {EventService} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class DcpSupportFormService extends SupportFormService {
  constructor(
    @Inject(PLATFORM_ID) protected platformId: object,
    protected launchDialogService: LaunchDialogService,
    protected eventService: EventService,
    protected configService: ConfigService
  ) {
    super(platformId, launchDialogService, configService);
  }

  override open(errorMessage?: string, errorCode?: string, targetUrl?: string): void {
    super.open(errorMessage, errorCode, targetUrl);
    this.triggerEddlSupportFormViewEvent();
  }

  private triggerEddlSupportFormViewEvent() {
    const event = new EddlFormViewEvent();
    event.name = SUPPORT_FORM_NAME;
    setTimeout(() => this.eventService.dispatch(event));
  }
}
